import React from 'react';
import SplitText from '../SplitText/SplitText';
import classes from './Header.module.css';

const Header = ({ header, styles, delay }) => {
  return (
    <>
      <SplitText
        copy={header}
        role={'heading'}
        classNameSpan={classes.header}
        className={styles ? styles : classes.header_text}
      />
    </>
  );
};

export default Header;
